import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import { Button, Tooltip } from "@mui/material";
import { useCallback, useContext } from "react";

import { ModalContext } from "contexts/ModalProvider";
import { useAuthentication } from "hooks/useAuthentication";
import { useShoppingCart } from "hooks/useShoppingCart";
import { useToast } from "hooks/useToast";
import { isCompanySeller } from "utils/models/user";

interface RepeatOrderButtonProps {
  orderId: string;
}

export const RepeatOrderButton = ({ orderId }: RepeatOrderButtonProps) => {
  const { infoToast } = useToast();
  const { user } = useAuthentication();
  const { setConfirmationModalProps } = useContext(ModalContext);
  const { items, openShoppingCart, repeatOrder } = useShoppingCart();
  const title = items?.length
    ? "Borrar productos y repetir pedido"
    : "Repetir pedido";
  const text = items?.length
    ? "¿Quieres borrar los productos del carrito y agregar este pedido?"
    : "¿Quieres agregar este pedido al carrito?";

  const onSubmit = useCallback(async () => {
    try {
      await repeatOrder(orderId);
      infoToast("Pedido agregado al carrito exitosamente");
      openShoppingCart();
      setConfirmationModalProps({ open: false });
    } catch (error) {
      console.error(error);
    }
  }, [
    repeatOrder,
    orderId,
    infoToast,
    openShoppingCart,
    setConfirmationModalProps,
  ]);

  if (isCompanySeller(user)) return null;
  return (
    <Tooltip title="Repetir pedido">
      <Button
        onClick={() =>
          setConfirmationModalProps({
            open: true,
            title,
            text,
            onSubmit,
          })
        }
      >
        <ShoppingCartCheckoutIcon titleAccess="Repetir pedido" />
      </Button>
    </Tooltip>
  );
};
